/** Tipos de propriedade operacional do frete (contrato API). */
export const FREIGHT_OWNERSHIP_TYPE = {
  PROPRIO: "PROPRIO",
  TRANSPORTADORA: "TRANSPORTADORA",
  /** Reservado — sem lógica de UI nesta entrega. */
  PLATAFORMA: "PLATAFORMA",
};

export function normalizeFreightOwnershipType(value) {
  const raw = String(value ?? "")
    .trim()
    .toUpperCase();
  if (raw === FREIGHT_OWNERSHIP_TYPE.TRANSPORTADORA) {
    return FREIGHT_OWNERSHIP_TYPE.TRANSPORTADORA;
  }
  if (raw === FREIGHT_OWNERSHIP_TYPE.PROPRIO) {
    return FREIGHT_OWNERSHIP_TYPE.PROPRIO;
  }
  if (raw === FREIGHT_OWNERSHIP_TYPE.PLATAFORMA) {
    return FREIGHT_OWNERSHIP_TYPE.PLATAFORMA;
  }
  return null;
}

/**
 * Embarcador (não transportadora / não viewALL) não vê
 * anunciado, sugerido, negociado e condição de pagamento
 * em frete TRANSPORTADORA.
 */
export function shouldHideDriverNegotiationFields({
  freightOwnershipType,
  viewALL = false,
  isViewerTransport = false,
} = {}) {
  if (viewALL === true) return false;
  if (isViewerTransport === true) return false;
  return (
    normalizeFreightOwnershipType(freightOwnershipType) ===
    FREIGHT_OWNERSHIP_TYPE.TRANSPORTADORA
  );
}

export function shouldHideDriverNegotiationOnFreightRecord(
  freight,
  { viewALL = false, isViewerTransport = false } = {},
) {
  return shouldHideDriverNegotiationFields({
    freightOwnershipType: freight?.freightOwnershipType,
    viewALL,
    isViewerTransport,
  });
}
